import { Action, Reducer } from "redux";
import { ClaimFileCategoryState, ClaimFileCategoryTypes, ClaimFileCategoryActionTypes } from "./claimFileCategoryTypes";

export const INITIAL_STATE: ClaimFileCategoryState = {
	claimFileCategory: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const claimFileCategoryReducer: Reducer<ClaimFileCategoryState> = (
	state: ClaimFileCategoryState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as ClaimFileCategoryActionTypes;
	switch (actionTypes.type) {
		case ClaimFileCategoryTypes.GET_CLAIM_FILE_CATEGORY:
			return {
				...state,
				claimFileCategory: { ...state.claimFileCategory, isLoading: true },
			};
		case ClaimFileCategoryTypes.SAVE_CLAIM_FILE_CATEGORY:
			return {
				...state,
				claimFileCategory: {
					...state.claimFileCategory,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ClaimFileCategoryTypes.RESET_REDUCER_CLAIM_FILE_CATEGORY:
			return {
				...state,
				claimFileCategory: INITIAL_STATE.claimFileCategory,
			};
		default:
			return state;
	}
};

export default claimFileCategoryReducer;
